import { Button, Card, CardActionArea, CardActions, CardContent, CardMedia, CircularProgress, Container, CssBaseline, Grid, Modal, TextField, Typography } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom';

import firebase from "firebase";
import EditTimeTable from './EditTimeTable';


const incominDATA = []

function EditTemplate(objData) {


    
    let { editID } = useParams();

    const [editState, setEditState] = useState(null)
    const [needsReRendering,setNeedsReRendering] = useState(false)
 

    let db = firebase.database();
  
    const history = useHistory();

    
  
    useEffect(() => {

      if(needsReRendering){setNeedsReRendering(false)}
      if(editState === null)
      {
        firebase.database().ref('EditPage/'+editID).once('value').then((promise)=>{setEditState(promise.val()) })
      }
      console.log(editState)
      

      return ()=>{
        document.cookie = "Day= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
      }
    },[editState,needsReRendering])
  
  
    function handleSubmit(e){
      e.preventDefault()
      setNeedsReRendering(true)
      firebase.database().ref('EditPage/'+editID).set(editState).then(()=>{window.location.reload(false)})
    }


    const InputText = (props)=>{
        const {obj,indx} = props
        const [textState, setTextState] = useState(obj.value)


        useEffect(()=>{
          let newState = editState;
          newState[indx].value = textState;
          setEditState(newState)

        },[textState])

        return <TextField 
        style={{width:"500px"}}
        variant="outlined"
        margin="normal"
        required
        fullWidth
        name={obj.id}
        onChange={e=>{setTextState(e.target.value)}}
        label={obj.name}
        value={textState}
        type="text"
        id={obj.id}
     
      />

    }
    const InputTextArea = (props)=>{
      const {obj,indx} = props
      const [textState, setTextState] = useState(obj.value)


       useEffect(()=>{
        let newState = editState;
        newState[indx].value = textState;
        setEditState(newState)

        },[textState])

        return <TextField 
        style={{width:"500px"}}
        variant="outlined"
        margin="normal"
        required
        fullWidth
        name={obj.id}
        onChange={e=>{setTextState(e.target.value)}}
        label={obj.name}
        value={textState}
        type="text"
        multiline
        rows={4}
        id={obj.id}
     
      />
    }


    const InputQuestion = (props)=>{

      const {obj,indx} = props
      const [questionState, setQuestionState] = useState(obj.value_Q)
      const [anwserState, setAnwserState] = useState(obj.value_A)


       useEffect(()=>{
        let newState = editState;
        newState[indx].value_Q = questionState;
        newState[indx].value_A = anwserState;
        setEditState(newState)
        return function cleanup (){
            setQuestionState(null)
            setAnwserState(null)
          }
        
        },[questionState,anwserState])

    
        const handleRemove = (e)=>{
          const anwser = window.confirm("Da li ste sigurni da želite pobrisati ovo pitanje")
          if(!anwser){return};
          let newState = editState.filter((e,index)=>{if(index!=indx)return e});
          setEditState(newState);
          firebase.database().ref('EditPage/'+editID).set(newState)
          setNeedsReRendering(true)
        }

        return <React.Fragment>

             Pitanje {1+indx}.
            <TextField 
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name={obj.id}
              onChange={e=>{setQuestionState(e.target.value)}}
              label={"Pitanje"}
              value={questionState}
              type="text"
              multiline
      
              id={obj.id}
          
            />

            <TextField 
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name={obj.id}
              onChange={e=>{setAnwserState(e.target.value)}}
              label={"Odgovor"}
              value={anwserState}
              type="text"
              multiline
    
              id={obj.id}
          
            />      
            <br/>
            <br/>

            <Button color="secondary"  variant="contained" onClick={handleRemove} style={{textAlign:"center",justifyContent:"center",float:"right"}}>IZBRIŠI PITANJE</Button>
        </React.Fragment>
        
 
    }



    	const InputImg = (props)=>{
        const {obj,indx} = props

        const [imgState, setImgState] = useState(obj.value)
        const [hideChangeImage,setHideChangeImage] =useState(true)
        const [spinner,setSpinner] =useState(false)
        const [uploadProgress,setUploadProgress] = useState(0)
        

        const  storageRef = firebase.storage().ref();
      
        const temporaryImageUpload = (e)=>{

          let newImage = e.target.files[0]

          let uploadTask = storageRef.child('Slike/Galerija/' + newImage.name).put(newImage);
          setSpinner(true)
          
          uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
          function(snapshot) {
              // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            setUploadProgress((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
            },
            function(errors){},
            function(){
              uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                console.log('File available at', downloadURL);
                setImgState(downloadURL)
                setSpinner(false)
              });
            }
          )
          
          }

    

        useEffect(()=>{
          console.log(imgState)
         let newState = editState;
         newState[indx].value = imgState;
         setEditState(newState)
 
         },[imgState])

        return <React.Fragment>

                    <Grid container direction="column" alignItems="center">
                    
                     <Card>
                        <CardActionArea>
       
                          <CardContent>  
            
                            {spinner?<React.Fragment><CircularProgress/><Typography>Učitano {uploadProgress} %</Typography></React.Fragment>:<img src={imgState} width="50%"/>}
                            <Typography gutterBottom variant="h5" component="h2">
                            {obj.name}
                            </Typography> 
                          </CardContent>

                        </CardActionArea>
                                    
                        <CardActions>
                          {/* TODO VRATI NATRAG */}
                          <Button size="small" color="primary" style={{"display":!hideChangeImage?"none":"default"}} onClick={()=>{setHideChangeImage(!hideChangeImage)}}>
                           Promjeni Sliku
                          </Button>
                           
                          <input type="file"  accept="image/*" autoFocus={true} hidden={hideChangeImage} onChange={temporaryImageUpload}/>
                          
                        </CardActions>
                                
                      </Card> 
                    </Grid>

        </React.Fragment>

           
          
        }

      function inputElement (obj,indx){
        switch(obj.type){
            case "input_text":
                return <InputText obj={obj} indx={indx}/>

            case "input_textarea":
                return <InputTextArea obj={obj} indx={indx}/>
            case "input_question":
                return <InputQuestion obj={obj} indx={indx}/>

            case "input_img":
               return <InputImg obj={obj} indx={indx}/>
    
        }

    }


    const AddNewQuestion=()=>{
      
      const [id_counter, setID_counter] = useState(null)
      const [openNewQuestion, setOpenNewQuestion] = useState(false)
      

      const [questionState, setQuestionState] = useState("")
      const [anwserState, setAnwserState] = useState("")




      const handleClose = ()=>{
        setQuestionState("");
        setAnwserState("");
        setOpenNewQuestion(false);
      }

      const handleNewQuestion =  (e)=>{
        e.preventDefault()

        const newQuestion = {
          id:"QA_"+id_counter,
          name:"Pitanje",
          type: "input_question",
          value_Q: questionState,
          value_A:anwserState, 
        }

        let newState = editState
        newState.push(newQuestion)
        setEditState(newState)
        
        handleSubmit(e)
  
         firebase.database().ref('EditPage/faq_counter').set(id_counter+1)
     

        setQuestionState("");
        setAnwserState("");
        //setOpenNewQuestion(false);
        console.log("došao")
        e.preventDefault()
        return false;
      }

      useEffect(()=>{

        if(id_counter === null)
        {
          firebase.database().ref('EditPage/faq_counter').once('value').then((promise)=>{setID_counter(promise.val()) })
        }
        return ()=>{
        setQuestionState("");
        setAnwserState("");
        setOpenNewQuestion(false);
        }
      },[id_counter])

    


      //TODO SPINNER IF NO STATE and onClick Form
      return <React.Fragment> 
      <Button color="primary" variant="contained" onClick={()=>setOpenNewQuestion(true)}>
        Dodaj Novo Pitanje
      </Button>

        <Modal
         style={{width:"50%",margin:"100px auto",height:"200px",backgroudColor:"white"}}
         open={openNewQuestion}
         onClose={handleClose}
         aria-labelledby="simple-modal-title"
         aria-describedby="simple-modal-description"
        >
            <React.Fragment>
              {/* TODO REMOVE FORM AND DO VALIDATION */}
              <form  style={{backgroundColor:"white",border:"5px solid lightblue"}} onSubmit={e=>handleNewQuestion(e)}>
          <TextField 
        
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name={"pitanje"}
              onChange={e=>{setQuestionState(e.target.value)}}
              label={"Pitanje"}
              value={questionState}
              type="text"
              multiline
            />
          
           
            <TextField 
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name={"odgovor"}
              onChange={e=>{setAnwserState(e.target.value)}}
              label={"Odgovor"}
              value={anwserState}
              type="text"
              multiline
    
          
            />  
                      
              <Button  color="primary" variant="contained" type="submit" >Dodaj Pitanje</Button>
              </form>
               </React.Fragment>
          </Modal>  
          
        
      </React.Fragment>
    }

    if(editID == "raspored"){return <EditTimeTable/>}

    return (
      <Container style={{width:"80%",padding:"20px"}}>
        <Grid container alignItems="center" direction="column">
          <CssBaseline />
          <Grid container direction="column" alignItems="center">
            <Typography variant="h5" color="textPrimary">
              Ispunite formu kako biste ste uredili podatke {editID}
            </Typography>
          </Grid>
          {/* TOPIC ID {editID} */}

         {editID === "faq"?<AddNewQuestion/>:null}

          {
          editState === null ?
           <CircularProgress />
           : 
           editState.map((el, indx) => ( <Grid item key={indx}>  {inputElement(el, indx)}</Grid> )) 
          }

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            onClick={handleSubmit}
            style={{width:"50%",marginTop:"20px"}}
          >
            Spremi Promjene
          </Button>
        </Grid>
      </Container>
        
    );
}

export default EditTemplate



